import { VaultObjectUploadData } from "@/components/vault/vault-object-util";
import { SubmitSticker } from "@/components/vault/viewer/stickers/SubmitSticker";
import { ViewerSticker } from "@/components/vault/viewer/stickers/ViewerSticker";
import {
  LoaderData,
  VaultObjectViewerData,
} from "@/components/vault/viewer/VaultObjectViewerModal";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";
import { AssetData } from "@/types/data-types";
import { VAULT_OBJECT_TYPE } from "@/types/enums";
import React, { RefObject } from "react";

interface VaultObjectViewerStickerProps {
  onCloseModal: () => void;
  logoRef: RefObject<HTMLDivElement>;
  titleRef: RefObject<HTMLDivElement>;
  panelRef: RefObject<HTMLDivElement>;
  actionButtonRef: RefObject<HTMLDivElement>;
  loaderData: LoaderData | null;
  canvasStatus: "idle" | "loading" | "render" | "error" | "hidden";
  vaultObjectViewerData: VaultObjectViewerData | null;
  wrapperSize:
    | {
        width: number;
        height: number;
      }
    | undefined;
  setCurrentTransformControlsMode: React.Dispatch<
    React.SetStateAction<"rotate" | "translate" | null>
  >;
  captureReady: boolean;
  uploadLoading: boolean;
  setUploadLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uploadComplete: boolean;
  setUploadComplete: React.Dispatch<React.SetStateAction<boolean>>;
  uploadFailed: boolean;
  setUploadFailed: React.Dispatch<React.SetStateAction<boolean>>;
  warnThumbnailClipping: boolean;
}

export const VaultObjectViewerSticker = ({
  onCloseModal,
  logoRef,
  titleRef,
  panelRef,
  actionButtonRef,
  loaderData,
  canvasStatus,
  vaultObjectViewerData,
  wrapperSize,
  setCurrentTransformControlsMode,
  captureReady,
  uploadLoading,
  setUploadLoading,
  uploadComplete,
  setUploadComplete,
  uploadFailed,
  setUploadFailed,
  warnThumbnailClipping,
}: VaultObjectViewerStickerProps) => {
  const currentPage = useVaultStore((state) => state.currentPage);
  const uploadData = useVaultStore((state) => state.uploadData);
  switch (currentPage) {
    case "viewer":
    case "uploader":
      return (
        <ViewerSticker
          onCloseModal={onCloseModal}
          logoRef={logoRef}
          titleRef={titleRef}
          panelRef={panelRef}
          actionButtonRef={actionButtonRef}
          loaderData={loaderData}
          canvasStatus={canvasStatus}
          vaultObjectViewerData={vaultObjectViewerData}
          asset={(() => {
            if (currentPage === "uploader") {
              return {
                type: VAULT_OBJECT_TYPE.OBJECT,
                data: {
                  ...uploadData,
                  fileList: uploadData?.file
                    ? [{ bytes: uploadData.file.size }]
                    : [],
                } as VaultObjectUploadData,
              };
            } else if (vaultObjectViewerData) {
              return {
                type: vaultObjectViewerData.type,
                data: vaultObjectViewerData.assetData as AssetData,
              };
            } else {
              return null;
            }
          })()}
        />
      );
    case "uploader-thumbnail":
      return (
        <SubmitSticker
          loaderData={loaderData}
          canvasStatus={canvasStatus}
          wrapperSize={wrapperSize}
          setCurrentTransformControlsMode={setCurrentTransformControlsMode}
          captureReady={captureReady}
          uploadLoading={uploadLoading}
          setUploadLoading={setUploadLoading}
          uploadComplete={uploadComplete}
          setUploadComplete={setUploadComplete}
          uploadFailed={uploadFailed}
          setUploadFailed={setUploadFailed}
          warnThumbnailClipping={warnThumbnailClipping}
        />
      );
  }
};
